export default __webpack_public_path__ + "static/media/cloud-gif.0fb2a792.gif";